export const extractQuickAppointmentConfirmationData = ({
  orderDetails: {
    orderId,
    revenue
  } = {},
  selectedServiceItems: {
    selectedServiceDetailsList = []
  } = {}
}) => ({
  orderId,
  tax: 0,
  revenue,
  totalPrice: 0,
  services: selectedServiceDetailsList
})

export const getNamesForEvent = (items) => {
  if (items[0].productName) {
    return items.map(item => item.productName)
  }

  return items.map(item => item.serviceName)
}

export const geIdsForEvent = (items) => items.map(item => item.skuId)
